import React, { useState, useEffect } from "react";
import { Dialog, Box } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomTextBox from "components/CustomTextBox";
import TextEditor from "components/TextEditor";
import CustomSnackBar from "components/CustomSnackBar";
import CustomComboBox from "components/CustomComboBox";
import { createDelivery } from "context/actions/delivery";

import { getBranchList } from "context/actions/branch";

const PageCompose = ({ open, handleClose, editItem, data, delivered }) => {
  const [name, setName] = useState("");
  const [content, setContent] = useState(editItem ? editItem.content : "");
  const [phone, setPhone] = useState(editItem ? editItem.phone : "");
  const [time, setValue] = useState(editItem ? editItem.time : "00:00");
  const [time1, setValue1] = useState(editItem ? editItem.time1 : "00:00");
  const [branchData, setBranch] = useState("");
  const [branchDataList, setBranchData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    editItem && editItem.news_date ? new Date(editItem.news_date) : null
  );
  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    // const resBranch = await getBranchList();
    // if (resBranch.status === "success") setBranchData(resBranch.data);
  };


  // const onChangeBranch = (value, id) => {
  //   setBranch(value);
  // };
  const handleSave = () => {
    const dataName = data.map((item) => item.name);
    const datas = {
      name,
      phone,
      content,
      selectedDate,
      time,
      time1,
      // branchData,
      dataName,
      data,
    };

    

    createDelivery(datas)
      .then((resUser) => {

     
        if (resUser.success === true) {
          setSnack({
            isOpen: true,
            msg: "Амжилттай",
            type: "success",
          });
          setTimeout(() => handleClose(), 300);
        } else {
          setSnack({
            isOpen: true,
            msg: "Мэдээллээ бүрэн оруулна уу",
            type: "error",
          });
        }
      })
      .catch(() => {
        setSnack({
          isOpen: true,
          msg: "Мэдээллээ бүрэн оруулна уу",
          type: "error",
        });
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      className="p-[5px] w-full  rounded-lg"
    >
      <Box className="p-[20px]">
        <h2 className="text-xl font-bold text-gray-800">{`Хүргэлтийн хаяг ${editItem ? "засах" : "нэмэх"}`}</h2>
        <div className="mt-5 space-y-4">
          <CustomTextBox label="Нэр" value={name} onChange={setName} />
          <CustomTextBox
            label="Утас"
            value={phone}
            onChange={setPhone}
            InputProps={{ type: "number" }}
          />
        </div>

        <div className="mt-5">
          {/* <label className="text-gray-500">Боломжит өдөр</label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
            <DatePicker
              selected={selectedDate}
              onChange={setSelectedDate}
              dateFormat="yyyy-MM-dd"
              isClearable
              className="border border-gray-300 rounded-md p-2 w-full"
              withPortal
            />
          </div> */}
          {/* <div className="flex justify-between mt-4">
            <div className="space-y-2">
              <label className="text-gray-500 mr-[20px]">Эхлэх цаг</label>
              <input
                type="time"
                value={time}
                onChange={(e) => setValue(e.target.value)}
                className="border border-gray-300 rounded-md p-2 w-full"
              />
            </div>
            <div className="space-y-2">
              <label className="text-gray-500 mr-[20px]">Дуусах дуусах</label>
              <input
                type="time"
                value={time1}
                onChange={(e) => setValue1(e.target.value)}
                className="border border-gray-300 rounded-md p-2 w-full"
              />
            </div>
          </div> */}
        </div>
        
          <div className="mt-5">
            <label className="text-gray-500 ">Хүргүүлэх хаяг оруулах</label>
            <CustomTextBox
              name="description"
              initData={content}
              onChange={setContent}
              rows={2}
            />
          </div>
        

        <div>
          <div
            style={{
              font: "normal 14px Tahoma",
              color: "green",
              marginTop: 20,
            }}
          >
            {"Тоо ширхэг : "} {data.length}
          </div>
          {/* <div
            style={{
              font: "normal 14px Tahoma",
              color: "green",
              marginTop: 10,
            }}
          >
            Төлөх дүн :{" "}
            {data
              .reduce((acc, category) => acc + parseInt(category.price, 10), 0)
              .toLocaleString("mn-MN")}{" "}
            ₮
          </div> */}
        </div>

        <CustomSnackBar
          open={snack.isOpen}
          msg={snack.msg}
          handleClose={() => setSnack({ ...snack, isOpen: false })}
          type={snack.type}
        />

        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-gray-200 rounded-md text-gray-700"
          >
            Цонхыг хаах
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-gray-800 text-white rounded-md"
          >
            Илгээх
          </button>
        </div>
      </Box>
    </Dialog>
  );
};

export default PageCompose;
